export default __webpack_public_path__ + "static/media/flayer33.f06b14ea.jpg";